/* eslint-disable @typescript-eslint/no-explicit-any */
export default class APIManager {
  apis: { [key: string]: (...args: any[]) => any }

  constructor() {
    this.apis = {};
  }

  add(key: string, fn: (...args: any[]) => any) {
    if (typeof (fn) !== 'function') {
      console.error('Added non-function to APIManager with key ' + key);
    }
    console.info('Registered API ' + key, fn);
    this.apis[key] = fn;
  }

  get(key: string) {
    return this.apis[key];
  }
}